const LyriaPaymentCallbackStatus = {
    SUCCESS: 'success',
    ERROR: 'error',
};

export default LyriaPaymentCallbackStatus;